import React, { useEffect, useState, useContext, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';
import Button from '@material-ui/core/Button';
import useGuiTranslations from '../MultiLanguage/useGuiTranslations';
import { capitalizeFirstLetter } from '../../Util/StringFunctions';

export default function UnpaidOrders__table(props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();
    const tableTotal = useRef(0);
    const [translateGui] = useGuiTranslations();
    //const currentTableId = useRef(0);

    const addToTableTotal = (toBeAdded) => {
        tableTotal.current = tableTotal.current + toBeAdded;
        return toBeAdded;
    }

    const getTableTotal = () => {
        let temp = tableTotal.current;
        tableTotal.current = 0;
        return temp;
    }

    const removeTable = () => {
        //props.addTableToCompletedPayments(props.table.customerTableId);
        globalContext.dispatchMethod(
            { 
                type: 'SET_MESSAGE', 
                value: { 
                    message: capitalizeFirstLetter(translateGui(122)), 
                    showButton: true,
                    doSmthIfOk: ()=> {props.addTableToCompletedPayments(props.table.customerTableId)},
                },
            });
    }

    return (
        <div className={classes.root}>
            <div className={classes.header}>
                <span>{capitalizeFirstLetter(translateGui(24))}:</span>
                <span>{props.table.tableNumber}</span>
            </div>
            <div className={classes.body}>
                {
                    props.table.purchaseOrderList.map(
                        purchaseOrder =>
                            purchaseOrder.orderDetail.map(
                                orderLine =>
                                    <div className={classes.orderLine}>
                                        <span>
                                            {orderLine.foodOrDrink}
                                        </span>
                                        <span>
                                            {addToTableTotal(orderLine.itemAmount)}
                                        </span>
                                    </div>
                            )
                    )

                }
                <div className={classes.totalLine}>
                    {getTableTotal().toFixed(2)}
                </div>
                
            </div>
            <div className={classes.bottom}>
            <Button onClick={()=>{removeTable()}}  variant="contained" color="primary">
                    {capitalizeFirstLetter(translateGui(121))}
                </Button>
            </div>

        </div>
    )
}

const useStyles = makeStyles({
    root: {
        boxShadow: '5px 5px 5px 0px rgba(0, 0, 0, 0.25)',
        backgroundColor: 'white',
        padding: '10px',
    },
    header:{
        fontFamily: 'Open Sans',
        backgroundColor: '#f7f7f7',

    },
    body: {
        margin: '10px 0',
    },
    orderLine:{
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '0.9rem',
        opacity: '0.9',
    },
    totalLine:{
        display:'flex',
        justifyContent: 'flex-end',
        paddingTop: '5px',
        fontWeight: '500',
        borderTop: '1px solid #dad7d7',
        marginTop: '10px',

    },
    bottom:{
        display:'flex',
        justifyContent: 'flex-end',
        paddingTop: '5px',
    }

});